/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_Scope_TeamInputs */

const cs_templates_use_picker_scope_team = /** @type {(inputs: Templates_Use_Picker_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tým`)
};

const en_templates_use_picker_scope_team = /** @type {(inputs: Templates_Use_Picker_Scope_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Templates_Use_Picker_Scope_TeamInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_scope_team = /** @type {((inputs?: Templates_Use_Picker_Scope_TeamInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_Scope_TeamInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_scope_team(inputs)
	return cs_templates_use_picker_scope_team(inputs)
});